import * as React from 'react';
import styled from 'styled-components';
import { SpaceProps, space } from 'styled-system';
import { Button, Icon, is, isNot, media } from '@packages/ui';

import { useCarousel, CarouselHeader } from '../Carousel';

const SliderWrapper = styled.div<SpaceProps>`
  position: relative;
  overflow: hidden;
  ${media.from.md`
    padding-left: 60px;
  `}
  ${space}
  &::after {
    content: ' ';
    width: 80px;
    height: 100%;
    pointer-events: none;
    z-index: 1;
    position: absolute;
    top: 0px;
    right: 0px;
    ${media.from.md`
      box-shadow: inset -55px 0px 25px -10px rgba(255, 255, 255, 0.97);
    `}
  }
`;

const ArrowStyled = styled(Button).attrs({ 'data-testid': 'carousel-arrow' })<{ alignLeft: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  padding: 0 8px;
  text-align: center;
  border-radius: 50%;
  display: none;
  ${media.from.md`
    display: block;
  `}
  ${is('alignLeft')`
    left: 0;
  `};
  ${isNot('alignLeft')`
    right: 0;
  `};
`;

interface ArrowProps {
  iconName: 'chevronRight' | 'chevronLeft';
  onClick: VoidFunction;
}

const Arrow: React.FC<ArrowProps> = ({ onClick, iconName }) => {
  return (
    <ArrowStyled onClick={onClick} alignLeft={iconName === 'chevronLeft'}>
      <Icon size={16} name={iconName} color="white" />
    </ArrowStyled>
  );
};

const sideMargin = [0, 0, 4, 4, 5];

export const ProductCarouselWrapper: React.FC<{ title?: string }> = ({ children, title }) => {
  const { nextSlide, prevSlide } = useCarousel();
  return (
    <>
      <CarouselHeader>{title}</CarouselHeader>
      <SliderWrapper mx={sideMargin}>
        <Arrow iconName="chevronLeft" onClick={prevSlide} />
        <Arrow iconName="chevronRight" onClick={nextSlide} />
        {children}
      </SliderWrapper>
    </>
  );
};
